import TopGator2 from '../src/assets/gym/TopGator2.jpg'
import TopGator3 from '../src/assets/gym/TopGator3.jpg'
import sfane from '../src/assets/gym/sfane.jpg'
import sfane1 from '../src/assets/gym/sfane1.jpg'
import TopGator from '../src/assets/gym/TopGator.jpg'
import TopGator1 from '../src/assets/gym/TopGator1.jpg'
import Killer from '../src/assets/gym/Killer.jpg'
import Killer1 from '../src/assets/gym/Killer1.jpg'
import CosmusFitwell from '../src/assets/gym/CosmusFitwell.jpg'
import CosmusFitwell1 from '../src/assets/gym/CosmusFitwell1.jpg'
import FATMUG from '../src/assets/gym/FATMUG.jpg'
import FATMUG1 from '../src/assets/gym/FATMUG1.jpg'
import Gym from '../src/assets/gym/Gym.jpg'
import Gym1 from '../src/assets/gym/Gym1.jpg'
import Heroz from '../src/assets/gym/Heroz.jpg'
import Heroz1 from '../src/assets/gym/Heroz1.jpg'
import Hyper from '../src/assets/gym/Hyper.jpg'
import Hyper1 from '../src/assets/gym/Hyper1.jpg'
// import Fashion1 from '../src/assets/gym/Fashion1.jpg'
// import Fashion1 from '../src/assets/gym/Fashion1.jpg'


const Gdata =[
    {
        img1: TopGator2,
        img2: TopGator3,
        title: "TopGator Gym",
        price: "399"
    },
    {
        img1: sfane,
        img2: sfane1,
        title: "Sfane Gym",
        price: "299"
    },
    {
        img1: TopGator,
        img2: TopGator1,
        title: "TopGator Gym",
        price: "399"
    },
    {
        img1: Killer,
        img2: Killer1,
        title: "Killer Gym",
        price: "459"
    },
    {
        img1: CosmusFitwell,
        img2: CosmusFitwell1,
        title: "Cosmus Fitwell Gym",
        price: "299"
    },
    {
        img1: FATMUG,
        img2: FATMUG1,
        title: "FATMUG Sports Duffel",
        price: "999"
    },
    {
        img1: Gym,
        img2: Gym1,
        title: "Gym",
        price: "499"
    },
    {
        img1: Heroz,
        img2: Heroz1,
        title: "Heroz Young Gym",
        price: "499"
    },
    {
        img1: Hyper,
        img2: Hyper1,
        title: "Hyper Adam Duffel Gym",
        price: "399"
    },
    // {
    //     img1: Fashion,
    //     img2: Fashion1,
    //     title: "Fashion 7 Leatherette Gym",
    //     price: "299"
    // },

]
export default Gdata;
// GearNew Killer CosmusFitwell